// extracted by mini-css-extract-plugin
export default {"root":"classes_root__S9+lG","form":"classes_form__qzj0s"};